exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ustYazi[data-v-2c6f5b3f]{margin-top:20px}", ""]);

// exports
